module.exports = __webpack_public_path__ + "static/media/testi-user.19ca7854.png";